import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./pageStyles.scss";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  InputAdornment,
  Menu,
  MenuItem,
  Modal,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import CustomButton from "../components/common/controls/CustomButton";
import Search from "@material-ui/icons/Search";
import DMSelect from "../components/common/controls/DMSelect";
import DMGrid from "../components/common/controls/Grid/DMGrid";
import AntSwitch from "../components/common/controls/AntSwitch";
import * as _ from "lodash";
import DMModelSelect from "../components/common/DMModelSelect";
import RulesandLayers from "../components/common/controls/RulesandLayers";
import DMModal from "../components/common/controls/DMModal";
import DMUpload from "../components/common/controls/DMUpload";
import * as drawingsAction from "../actions/drawingAction";
import CloseIcon from "@material-ui/icons/Close";
import Brightness1 from "@material-ui/icons/Brightness1";
import * as viewsAction from "../actions/viewsAction";
import * as miscAction from "../actions/miscAction";
import * as modelAction from "../actions/modelAction";
import AddNewDrawingModal from "./AddNewDrawingModal/AddNewDrawingModal";
import Loading from "../components/Loading/Loading";
import {
  getPreSignedUrl,
  getMultipleSignedUrl,
  uploadNewDrawingToS3,
  createNewDrawing,
  getUploadedDrawings,
} from "../services/DrawingsService";
import DMDeleteDialog from "../components/common/controls/DMDeleteDialog";
import WarningPopup from "../components/common/controls/warningPopup";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";
import { constants } from "../constants/constants";

const Drawings = ({
  drawingsState,
  getDrawings,
  miscState,
  getViews,
  viewsState,
  deleteDrawing,
  updateDrawing,
  setSnackBar,
  onPageSelected,
  onCloseSelected,
  intl,
  fullLangCode,
}) => {
  // const history = useHistory();
  const [gridData, setGridData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [showNewDD, setShowNewDD] = useState(false);
  const [newDD, setNewDD] = useState();
  const [showEdit, setShowEdit] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [selectedDD, setSelectedDD] = useState();
  const [views, setViews] = useState([]);
  const [openAddNewDrawingModal, setOpenAddNewDrawingModal] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const onNewDDClick = () => setShowUpload(false);

  const [unsaveChangePopup, setUnsaveChangePopup] = useState(false);
  const [isUnsaveChanges, setIsUnsaveChanges] = useState(false);

  const uploadClick = () => {
    setShowUpload(true);
  };

  const addNewRow = () => {
    setOpenAddNewDrawingModal(true);
  };

  const headerItems = [
    {
      colName: "Drawing Name",
      sortable: true,
      key: "drawingName",
      name: "drawingName",
    },
    { colName: "View", sortable: true, key: "viewName", name: "viewName" },
    {
      colName: "Page Number",
      sortable: true,
      key: "pageNumber",
      name: "pageNumber",
    },
    {
      colName: "Page Label",
      sortable: true,
      key: "pageLabel",
      name: "pageLabel",
    },
    {
      colName: "Page Description",
      sortable: true,
      key: "pageDescription",
      name: "pageDescription",
    },
  ];

  const sortByList = [
    { label: "Drawing Name", value: "drawingName" },
    { label: "View", value: "viewName" },
    { label: "Page Number", value: "pageNumber" },
    { label: "Page Label", value: "pageLabel" },
    { label: "Page Description", value: "pageDescription" },
  ];

  const getDDFields = (ddField) => {
    return [
      { name: "Job Name", value: ddField.jobName },
      { name: "Buyer Name", value: ddField.buyerName },
      { name: "Sales Engineer", value: ddField.saleEngineer },
      { name: "Model Number", value: ddField.modelNumber },
      { name: "Job Number", value: ddField.jobNumber },
      { name: "P.O. Number", value: ddField.poNumber },
      { name: "Prepared By", value: ddField.preparedBy },
      { name: "Electric Char", value: ddField.electricChar },
      { name: "Note 1", value: ddField.note1 },
      { name: "Note 2", value: ddField.note2 },
      { name: "Job Location", value: ddField.jobLocation },
      { name: "Other", value: ddField.other },
      { name: "Sales Office", value: ddField.salesOffice },
      { name: "Date", value: ddField.date },
      { name: "Revision", value: ddField.revision },
    ];
  };

  const handleChange = (value) => {
    setSortBy(value);
  };

  const handleStatusNewDD = (value) => {
    setNewDD({ ...newDD, status: value });
  };
  const [drawings, setDrawings] = useState([]);
  const [drawingsOptions, setDrawingsOptions] = useState([]);

  const fetchUploadedDrawings = async () => {
    window.startLoading();
    await getUploadedDrawings(miscState?.selectedModel)
      .then((res) => {
        let temp = [];
        res.data.forEach((ele) => {
          const str = ele.replace(".zip", ".dxf");
          temp.push({
            title: injectIntlTranslation(intl, str, str),
            viewId: str,
          });
        });
        setDrawingsOptions(temp);
        return temp;
      })
      .catch((err) => {
        console.log("Fetch JSON file Error: ", err);
        return [];
      })
      .finally(() => {
        window.stopLoading();
      });
  };

  const onEdit = (modelId) => {
    onCloseSelected({
      id: uuidv4(),
      isClosed: false,
    });
    setShowEdit(true);
    setSelectedDD(drawings.filter((m) => m.modelId === modelId)[0]);
  };

  const onDelete = (dd) => {
    setShowDelete(true);
    setSelectedDD(dd);
  };

  const handleSearch = _.debounce(function (val) {
    setSearchValue(val?.toLowerCase());
  }, 700);

  const updatePropertyName = (inputArray, oldPropertyName, newPropertyName) => {
    const updatedArray = inputArray.map((obj) => {
      const { [oldPropertyName]: propertyValue, ...rest } = obj;
      return {
        [newPropertyName]: propertyValue,
        ...rest,
      };
    });
    return updatedArray;
  };

  const isDrawingViewPresent = (selectedView, dd, allDrawings) => {
    let isPresent = false;

    for (let drawing of allDrawings) {
      if (
        dd?.drawingName?.toLowerCase() ===
          drawing?.drawingName?.toLowerCase() &&
        selectedView.viewId === drawing.viewId
      ) {
        isPresent = true;
        break;
      }
    }
    return isPresent;
  };

  async function onUpdateConfigGroups(model, dd, value) {
    if (isDrawingViewPresent(value, dd, drawingsState?.drawings?.data)) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "drawingAlreadyExist",
          constants.drawingAlreadyExist
        )
      );
      setGridData([]);
      setDrawings([...drawingsState?.drawings?.data]);
      return;
    }

    try {
      const payload = {
        drawingId: dd?.drawingId,
        modelId: dd?.modelId,
        viewId: value?.viewId,
        drawingName: dd?.drawingName,
        sourceUrl: dd?.sourceUrl,
        pageNumber: dd?.pageNumber,
        pageLabel: dd?.pageLabel,
        pageDescription: dd?.pageDescription,
      };

      await updateDrawing(payload);

      if (!drawingsState?.updateDrawing?.hasError) {
        await getDrawings(miscState.selectedModel);
        setSnackBar(
          true,
          "success",
          injectIntlTranslation(
            intl,
            "updateDrawingView",
            constants.updateDrawingView
          )
        );
      } else {
        setSnackBar(
          true,
          "error",
          injectIntlTranslation(
            intl,
            "drawingNameError",
            constants.drawingNameError
          )
        );
        setGridData([]);
        setDrawings([...drawingsState?.drawings?.data]);
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "updateDrawingError",
          constants.updateDrawingError
        )
      );
      setGridData([]);
      setDrawings([...drawingsState?.drawings?.data]);
    }
  }

  const getSelectedValue = (searchText) => {
    const matchedvalue = views?.find((val) => val.viewId === searchText);
    return matchedvalue?.label;
  };

  useEffect(() => {
    onPageSelected(1);
    setSortBy(sortByList[0].value);
  }, []);

  useEffect(() => {
    setViews([]);
    getViews(miscState?.selectedModel);
    onPageSelected(1);
    // fetchUploadedDrawings();
  }, [miscState?.selectedModel]);

  useEffect(() => {
    let oldArray = viewsState.views.data;
    const updatedArray = updatePropertyName(oldArray, "viewName", "label");
    setViews(updatedArray);
  }, [viewsState.views.data]);

  useEffect(() => {
    if (viewsState.views.hasError) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "retriveViewError",
          constants.retriveViewError
        )
      );
    }
  }, [viewsState.views.hasError]);

  const uuidv4 = () => {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  };

  const isDrawingPresent = (
    updatedDrawingName,
    selectedDrawing,
    allDrawings
  ) => {
    let isPresent = false;

    for (let drawing of allDrawings) {
      if (
        updatedDrawingName === drawing.drawingName
        // selectedDrawing.viewId === drawing.viewId
      ) {
        isPresent = true;
        break;
      }
    }

    return isPresent;
  };

  const onUpdateDrawingName = async (model, dd, updatedName) => {
    if (dd?.drawingName === updatedName) {
      return;
    }
    if (isDrawingPresent(updatedName, dd, drawingsState?.drawings?.data)) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "drawingAlreadyExist",
          constants.drawingAlreadyExist
        )
      );
      setGridData([]);
      setDrawings([...drawingsState?.drawings?.data]);
      return;
    }

    try {
      const payload = {
        drawingId: dd?.drawingId,
        modelId: dd?.modelId,
        viewId: dd?.viewId,
        drawingName: updatedName,
        sourceUrl: dd?.sourceUrl,
        pageNumber: dd?.pageNumber,
        pageLabel: dd?.pageLabel,
        pageDescription: dd?.pageDescription,
      };

      await updateDrawing(payload);

      if (!drawingsState?.updateDrawing?.hasError) {
        await getDrawings(miscState.selectedModel);
        setSnackBar(
          true,
          "success",
          `${injectIntlTranslation(
            intl,
            "updateDrawingName",
            constants.updateDrawingName
          )} ${updatedName}`
        );
      } else {
        setSnackBar(
          true,
          "error",
          injectIntlTranslation(
            intl,
            "drawingNameError",
            constants.drawingNameError
          )
        );
        setGridData([]);
        setDrawings([...drawingsState?.drawings?.data]);
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `${injectIntlTranslation(
          intl,
          "drawingNameError",
          constants.drawingNameError
        )} ${updatedName}`
      );
      setGridData([]);
      setDrawings([...drawingsState?.drawings?.data]);
    }
  };

  const onUpdateDrawingPageInfo = async (model, dd, updatedVal, valFor) => {
    if (valFor === "pageNumber" && (!updatedVal || !Number(updatedVal))) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(intl, "pageNoError", constants.pageNoError)
      );
      setGridData([]);
      setDrawings([...drawingsState?.drawings?.data]);
      return;
    }

    if (valFor === "pageNumber" && dd?.pageNumber === updatedVal) {
      return;
    }
    if (valFor === "pageLabel" && dd?.pageLabel === updatedVal) {
      return;
    }
    if (valFor === "pageDescription" && dd?.pageDescription === updatedVal) {
      return;
    }

    const pageNumber = valFor === "pageNumber" ? updatedVal : dd?.pageNumber;
    const pageLabel = valFor === "pageLabel" ? updatedVal : dd?.pageLabel;
    const pageDescription =
      valFor === "pageDescription" ? updatedVal : dd?.pageDescription;

    try {
      const payload = {
        drawingId: dd?.drawingId,
        modelId: dd?.modelId,
        viewId: dd?.viewId,
        drawingName: dd?.drawingName,
        sourceUrl: dd?.sourceUrl,
        pageNumber,
        pageLabel,
        pageDescription,
      };

      await updateDrawing(payload);

      if (!drawingsState?.updateDrawing?.hasError) {
        await getDrawings(miscState.selectedModel);
        setSnackBar(
          true,
          "success",
          injectIntlTranslation(
            intl,
            "pageInfoUpdated",
            constants.pageInfoUpdated
          )
        );
      } else {
        setSnackBar(
          true,
          "error",
          injectIntlTranslation(intl, "pageInfoError", constants.pageInfoError)
        );
        setGridData([]);
        setDrawings([...drawingsState?.drawings?.data]);
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(intl, "pageInfoError", constants.pageInfoError)
      );
      setGridData([]);
      setDrawings([...drawingsState?.drawings?.data]);
    }
  };

  useEffect(() => {
    setLoading(drawingsState.drawings.isLoading);
  }, [drawingsState.drawings.isLoading]);

  useEffect(() => {
    const ctrlData = [];
    let updatedGrid = [];
    const drawings = [...drawingsState.drawings.data];
    if (viewsState.views.data.length > 0) {
      updatedGrid = drawings.map((item) => {
        return { ...item, viewName: getSelectedValue(item?.viewId) };
      });
    }
    if (searchValue.length > 0) {
      onPageSelected(1);
    }
    let filteredDrawings = updatedGrid?.filter(
      (e) =>
        e?.drawingName?.toLowerCase()?.includes(searchValue) ||
        e?.pageLabel?.toLowerCase()?.includes(searchValue) ||
        e?.pageDescription?.toLowerCase()?.includes(searchValue) ||
        e?.viewName?.toLowerCase()?.includes(searchValue)
    );

    filteredDrawings = filteredDrawings.map((item) => {
      return {
        ...item,
        pageNumber: item.pageNumber === null ? "" : item.pageNumber.toString(),
      };
    });

    const viewsOption = _.sortBy(views, "sort");

    if (views.length)
      _.sortBy(
        filteredDrawings,
        sortBy !== "" ? (obj) => obj[sortBy]?.toLowerCase() : sortBy
      ).forEach((dd) => {
        ctrlData.push({
          rowId: uuidv4(),
          rowKey: dd.drawingId,
          drawingName: dd?.drawingName,
          viewName: dd?.viewName,
          pageNumber: dd?.pageNumber,
          pageLabel: dd?.pageLabel,
          pageDescription: dd?.pageDescription,
          rowValue: [
            {
              colType: "contained-label",
              colOptions: {
                value: dd.drawingName,
                width: "260px",
                tab: "DrawingName",
                dd,
                onUpdate: onUpdateDrawingName,
                fullLangCode: fullLangCode,
              },
            },
            {
              colType: "grid-select",
              colOptions: {
                tab: "DD-ConfigType",
                dd: dd,
                searchPlaceHolderText: injectIntlTranslation(
                  intl,
                  "searchForView",
                  constants.searchForView
                ),
                selectInfoText: injectIntlTranslation(
                  intl,
                  "selectAView",
                  constants.selectAView
                ),
                selectedValue: dd?.viewName,
                menuList: viewsOption,
                width: "80%",
                textWidth: "150px",
                popperWidth: "324px",
                popperHeight: "300px",
                onUpdate: onUpdateConfigGroups,
                onChange: () => {
                  // setShowAlert(true); setAlertSeverity('success'); setAlertMessage(`${model.ddName}-${model.regionName} has been updated.`)
                },
              },
            },
            {
              colType: "contained-label",
              colOptions: {
                value: dd.pageNumber,
                width: "96px",
                dd,
                tab: "DD-Desc",
                onUpdate: (model, dd, updatedVal) =>
                  onUpdateDrawingPageInfo(model, dd, updatedVal, "pageNumber"),
              },
            },
            {
              colType: "contained-label",
              colOptions: {
                value: dd.pageLabel,
                width: "100px",
                dd,
                tab: "DD-Desc",
                fullLangCode: fullLangCode,
                onUpdate: (model, dd, updatedVal) =>
                  onUpdateDrawingPageInfo(model, dd, updatedVal, "pageLabel"),
              },
            },
            {
              colType: "contained-label",
              colOptions: {
                value: dd.pageDescription,
                width: "280px",
                dd,
                tab: "DD-Desc",
                fullLangCode: fullLangCode,
                onUpdate: (model, dd, updatedVal) =>
                  onUpdateDrawingPageInfo(
                    model,
                    dd,
                    updatedVal,
                    "pageDescription"
                  ),
              },
            },
            {
              colType: "grid-actions",
              colOptions: [
                {
                  name: "edit",
                  tab: "drawing",
                  action: () => onEdit(dd.modelId),
                  onCloseSidePanel: () => {
                    if (isUnsaveChanges) {
                      setUnsaveChangePopup(true);
                    } else {
                      onCloseSelected({
                        id: "",
                        isClosed: true,
                      });
                    }
                  },
                  width: "1300px",
                  sidePanelContent: (
                    <RulesandLayers
                      title={dd.drawingName}
                      rules={dd}
                      viewName={getSelectedValue(dd?.viewId) || ""}
                      isUnsaveChanges={isUnsaveChanges}
                      setIsUnsaveChanges={(val) => {
                        setIsUnsaveChanges(val);
                      }}
                      drawings={drawings}
                    />
                  ),
                },
                { name: "delete", action: () => onDelete(dd) },
              ],
            },
          ],
        });
      });
    setGridData(ctrlData);
  }, [drawings, searchValue, sortBy, views, isUnsaveChanges, fullLangCode]);

  useEffect(() => {
    getDrawings(miscState?.selectedModel);
    setDrawings(drawingsState?.drawings?.data);
  }, [miscState?.selectedModel]);

  useEffect(() => {
    setDrawings(drawingsState.drawings.data);
  }, [drawingsState.drawings.data]);

  function getModalStyle() {
    const top = 55;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
      width: "70%",
      minWidth: "1300px",
      minHeight: "350px",
      borderRadius: "10px",
      boxShadow: "rgba(0,0,0,0.35) 0px 5px 15px",
    };
  }

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
    },
    formControl: {
      minWidth: 222,
      "& .MuiSelect-root": {
        padding: "10px",
      },
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    gridHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "25% 20% 10% 10% 30% 4%",
      color: "#617080",
      fontSize: "14px",
      fontFamily: "Roboto",
      fontWeight: "500",
    },
  }));

  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = useState(getModalStyle);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {};

  const handleMoreOptionsClose = (pageName) => {
    setAnchorEl(null);
    // history.push(`/${pageName}`)
  };

  const modelsList = [
    { label: "19MV-ASIA", value: 0 },
    { label: "30KAV-EMEA", value: 1 },
    { label: "30KAV-NA", value: 2 },
    { label: "19MV-EMEA", value: 3 },
    { label: "30KAV-ASIA", value: 4 },
  ];

  /* Delete Rule */
  const deleteConfirm = async () => {
    try {
      const payload = {
        DrawingId: selectedDD.drawingId,
      };
      await deleteDrawing(payload);
      if (!drawingsState?.deleteDrawing?.hasError) {
        await getDrawings(miscState.selectedModel);
        setDrawings(drawingsState?.drawings?.data);
        setShowDelete(false);
        setSnackBar(
          true,
          "success",
          `${injectIntlTranslation(
            intl,
            "drawingDeleteSuccess",
            constants.drawingDeleteSuccess
          )} ${selectedDD?.drawingName}`
        );
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `${injectIntlTranslation(
          intl,
          "drawingDeleteError",
          constants.drawingDeleteError
        )} ${selectedDD.drawingId}`
      );
    }
  };

  const [modelID, setModelID] = useState(modelsList[0].label);

  const getFileData = (fileData) => {
    let payload = {
      modelId: miscState?.selectedModel,
      FileNames: fileData.map((ele) => ele.zipFileName),
    };

    window.startLoading();

    getMultipleSignedUrl(payload)
      .then((response) => {
        const data = response.data;

        if (data?.length) {
          let temp = [];
          data.forEach((url) => {
            let [d = null] = fileData.filter(
              (ele) => ele.zipFileName === url.fileName
            );

            if (d) {
              let newPromise = uploadNewDrawingToS3(url.url, d.file);
              temp.push(newPromise);
            }
          });

          Promise.all(temp)
            .then((res) => {
              getDrawings(miscState?.selectedModel);
              setShowUpload(false);
              window.stopLoading();
              setSnackBar(
                true,
                "success",
                injectIntlTranslation(
                  intl,
                  "drawingUploadSuccess",
                  constants.drawingUploadSuccess
                )
              );
            })
            .catch((error) => {
              window.stopLoading();
              console.log("Batch Upload error: ", error);
              setSnackBar(
                true,
                "error",
                injectIntlTranslation(
                  intl,
                  "drawingUploadError",
                  constants.drawingUploadError
                )
              );
            });
        }
      })
      .catch((error) => {
        window.stopLoading();
        setSnackBar(
          true,
          "error",
          injectIntlTranslation(
            intl,
            "uploadFilemodelIdError",
            constants.uploadFilemodelIdError
          )
        );
      });
  };

  const uploadToS3WithPreSignedURL = async (presignedUrl, fileData) => {
    const { fileName, file } = fileData;
    window.startLoading();
    uploadNewDrawingToS3(presignedUrl, file)
      .then((response) => {
        const data = response.data;
        setSnackBar(
          true,
          "success",
          `${injectIntlTranslation(
            intl,
            "drawingUploadSuccess",
            constants.drawingUploadSuccess
          )} ${fileName}`
        );
      })
      .catch((error) => {
        setSnackBar(
          true,
          "error",
          `${injectIntlTranslation(
            intl,
            "uploadFilemodelIdError",
            constants.uploadFilemodelIdError
          )}`
        );
      })
      .finally(() => {
        window.stopLoading();
      });
  };

  const handleModelId = (e) => {
    setModelID(e.target.value);
  };

  const isValidFile = (isValid) => {
    if (!isValid) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(intl, "validDXFerror", constants.validDXFerror)
      );
    }
  };

  const createNewDrawingHandler = async (selectedValue) => {
    const {
      selectedModel,
      drawingName,
      selectedView,
      pageNumber,
      pageLabel,
      pageDescription,
    } = selectedValue;

    const payload = {
      modelId: selectedModel,
      ViewId: selectedView?.viewId,
      DrawingName: drawingName,
      PageNumber: pageNumber,
      PageLabel: pageLabel,
      PageDescription: pageDescription,
    };

    const selectView = {
      drawingName: drawingName,
      viewId: selectedView?.viewId,
    };
    if (
      isDrawingViewPresent(
        selectView,
        selectView,
        drawingsState?.drawings?.data
      )
    ) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "drawingAlreadyExist",
          constants.drawingAlreadyExist
        )
      );
      setGridData([]);
      setDrawings([...drawingsState?.drawings?.data]);
      return;
    }

    setShowLoading(true);
    const response = await createNewDrawing(payload);
    if (response?.status === 201) {
      setSnackBar(
        true,
        "success",
        `${injectIntlTranslation(
          intl,
          "recordAddedSuccess",
          constants.recordAddedSuccess
        )} ${drawingName} `
      );
      await getDrawings(selectedModel);
    } else {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "recordAddedError",
          constants.recordAddedError
        )
      );
    }
    setShowLoading(false);
  };

  const onSelectedPage = (selectedPage) => {
    onPageSelected(selectedPage);
  };

  return (
    <div container className="page-container content-center drawing-wrapper">
      <Loading open={showLoading} />

      <Grid container xs={12} md={9} className="page-content">
        <div style={{ width: "100%" }}>
          <div style={{ display: "flex", width: "100%" }}>
            <div>
              <DMModelSelect name={selectedDD?.drawingName} />
            </div>

            <div
              style={{
                marginLeft: "auto",
                height: "29px",
                borderBottom: "1px solid #8f8f8f",
                marginRight: "15px",
                width:"270px"
              }}
            >
              <TextField
                id="search"
                placeholder={injectIntlTranslation(
                  intl,
                  "searchPlacholder",
                  constants.searchPlacholder
                )}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => handleSearch(e.target.value)}
                autoComplete={"off"}
              />
            </div>
            <div>
              <DMSelect
                id="sort-by-select"
                label={injectIntlTranslation(
                  intl,
                  "sortByLabel",
                  constants.sortByLabel
                )}
                lists={sortByList}
                onChange={handleChange}
                defaultValue={sortByList[0].value}
                styles={{
                  width: "fit-content",
                  // border: "1px solid #8f8f8f",
                  // borderRadius: "5px",
                  // padding: "0px 10px",
                  minWidth: "180px",
                  width:"100%"
                }}
              />
            </div>
          </div>

          <div
            style={{
              display: "flex",
              width: "100%",
              marginTop: "10px",
              marginBottom: "15px",
            }}
          >
            <div style={{ marginLeft: "auto", marginRight: "15px" }}>
              <CustomButton
                id="newDDName"
                showGradient={true}
                variant="contained"
                color="primary"
                disabled={false}
                name={injectIntlTranslation(
                  intl,
                  "uploadDrawing",
                  constants.uploadDrawing
                )}
                onClick={uploadClick}
              />
            </div>
            <div>
              <CustomButton
                id="newDDName"
                showGradient={true}
                variant="contained"
                color="primary"
                disabled={false}
                name={injectIntlTranslation(
                  intl,
                  "addNewRecord",
                  constants.addNewRecord
                )}
                onClick={addNewRow}
              />
            </div>
          </div>
        </div>
        {gridData.length > 0 && (
          <DMGrid
            headers={headerItems}
            headerClassName={classes.gridHeaderColumns}
            loading={false}
            data={gridData}
            selectedPage={drawingsState.selectedPage}
            onPageSelection={onSelectedPage}
          />
        )}
        <Modal open={showNewDD} onClose={() => setShowNewDD(false)}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title">
              {injectIntlTranslation(
                intl,
                "createNewDDTitle",
                constants.createNewDDTitle
              )}
            </h3>
            <form style={{ textAlign: "center" }}>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <TextField
                    id="outlined-basic"
                    label={injectIntlTranslation(
                      intl,
                      "DDNameLabel",
                      constants.DDNameLabel
                    )}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={12}>
                  <Typography
                    component="div"
                    style={{ display: "inline-block" }}
                  >
                    <Grid
                      component="label"
                      container
                      alignItems="center"
                      spacing={1}
                    >
                      <Grid item>
                        <Typography style={{ fontSize: "20px" }}>
                          {injectIntlTranslation(
                            intl,
                            "statusLabel",
                            constants.statusLabel
                          )}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <AntSwitch
                          checked={newDD?.status}
                          onChange={handleStatusNewDD}
                          name={injectIntlTranslation(
                            intl,
                            "statusLabel",
                            constants.statusLabel
                          )}
                        />
                      </Grid>
                    </Grid>
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  container
                  style={{ justifyContent: "center" }}
                >
                  <Grid item xs={6}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => setShowNewDD(false)}
                    >
                      {injectIntlTranslation(
                        intl,
                        "createBtnLabel",
                        constants.createBtnLabel
                      )}
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="outlined"
                      onClick={() => setShowNewDD(false)}
                    >
                      {injectIntlTranslation(
                        intl,
                        "cancelBtnLabel",
                        constants.cancelBtnLabel
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </div>
        </Modal>

        <Modal open={showEdit} onClose={() => setShowEdit(false)}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title">
              {selectedDD?.ddName} -{" "}
              {injectIntlTranslation(
                intl,
                "information",
                constants.information
              )}
            </h3>
            <form style={{ textAlign: "center", scrollBehavior: "auto" }}>
              <Grid container spacing={1}>
                {selectedDD &&
                  getDDFields(selectedDD).map((m) => {
                    return (
                      <Grid item xs={12}>
                        <TextField
                          size="small"
                          id="outlined-basic"
                          label={m.name}
                          variant="outlined"
                          value={m.value}
                        />
                      </Grid>
                    );
                  })}
              </Grid>
            </form>
          </div>
        </Modal>

        <WarningPopup
          open={showDelete}
          onClose={() => setShowDelete(false)}
          title={injectIntlTranslation(
            intl,
            "modelDeleteTitle",
            constants.modelDeleteTitle
          )}
          description={
            <>
              {`${injectIntlTranslation(
                intl,
                "modelDeleteTitle",
                constants.modelDeleteTitle
              )} `}
              <b>{selectedDD?.drawingName}</b>.
            </>
          }
          saveButtonLabel={`${injectIntlTranslation(
            intl,
            "deleteBtnLabel",
            constants.deleteBtnLabel
          )}`}
          onSave={() => {
            deleteConfirm();
          }}
        />

        <WarningPopup
          width={"600px"}
          open={showUpload}
          onClose={() => setShowUpload(false)}
          title={injectIntlTranslation(
            intl,
            "uploadDrawings",
            constants.uploadDrawings
          )}
          description={
            <div style={{ padding: "20px" }}>
              <DMUpload sendFileData={getFileData} validateFile={isValidFile} />
            </div>
          }
          hideBtn={true}
        />

        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => setShowMoreOptions(false)}
        >
          <MenuItem onClick={() => handleMoreOptionsClose("datadesc")}>
            Edit DdNames
          </MenuItem>
          <MenuItem onClick={() => handleMoreOptionsClose("views")}>
            Edit Views
          </MenuItem>
          <MenuItem onClick={() => handleMoreOptionsClose("drawings")}>
            Edit Drawings
          </MenuItem>
        </Menu>
      </Grid>
      <AddNewDrawingModal
        open={openAddNewDrawingModal}
        selectedModel={miscState.selectedModel}
        views={viewsState?.views?.data}
        drawingsOptions={drawingsOptions}
        onClose={() => setOpenAddNewDrawingModal(false)}
        onCreate={createNewDrawingHandler}
        key={openAddNewDrawingModal}
        fetchUploadedDrawings={fetchUploadedDrawings}
      />

      {/* Dialog for unsave chabges warning */}
      <WarningPopup
        open={unsaveChangePopup}
        onClose={() => setUnsaveChangePopup(false)}
        title={injectIntlTranslation(
          intl,
          "unsaveWarningTitle",
          constants.unsaveWarningTitle
        )}
        description={injectIntlTranslation(
          intl,
          "unsaveWarningContent",
          constants.unsaveWarningContent
        )}
        saveButtonLabel={injectIntlTranslation(
          intl,
          "yesBtnLable",
          constants.yesBtnLable
        )}
        onSave={() => {
          onCloseSelected({
            id: "",
            isClosed: true,
          });
          setUnsaveChangePopup(false);
          setIsUnsaveChanges(false);
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  drawingsState: state.drawing,
  miscState: state.misc,
  viewsState: state.views,
  fullLangCode: state.locale.message,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getDrawings: async (modelId) =>
      dispatch(drawingsAction.getDrawings(modelId)),
    getViews: async (modelId) => dispatch(viewsAction.getViews(modelId)),
    deleteDrawing: async (requestPayload) =>
      dispatch(drawingsAction.deleteDrawing(requestPayload)),
    updateDrawing: async (requestPayload) =>
      dispatch(drawingsAction.updateDrawing(requestPayload)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    onPageSelected: (selectedPage) =>
      dispatch(drawingsAction.setDrawingSelectedPage(selectedPage)),
    onCloseSelected: (data) => dispatch(miscAction.onCloseSelected(data)),
  };
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(Drawings)
);
